import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import moment from 'moment';
import QRCode from "react-qr-code";
import constClass from '../../Constants/Constants';
import Common from '../Common/common';
import { Link } from 'react-router-dom';
import Loading from '../Loading/Loading';
import Modal from 'react-modal';
import CloseImg from '../Images/close.svg';
import 'bootstrap-icons/font/bootstrap-icons.css';

let membership_id = null;

const MembershipPass = ({ siteId, mallId, shopCode, customerId, lineId, liffAccessToken, setting, footerHeight, refreshAvailablePoints }) => {
  const [qrData, setQrData] = useState(null);
  const [validTime, setValidTime] = useState(moment());
  const [restTime, setRestTime] = useState(0);
  const [userInfo, setUserInfo] = useState({
    membership_id: null, //会員ID
    customer_name: '', //お客様名
    available_point: 0, //利用可能ポイント
    expire_point: 0, //有効期限が直近の残りポイント
    expire_point_date: null, //有効期限が直近の期日
    user_rank_point: 0, //会員ランクを決定する為のポイント
    user_rank: 1, //現在の会員ランク
    point_upper: 0,
    nimocle_linkage_status: null, //nimocle連携ステータス
  });
  const [rankInfo, setRankInfo] = useState([]);
  const [showRankGuide, setShowRankGuide] = useState(false);
  const [showLotteryGuide, setShowLotteryGuide] = useState(false);
  const [modalFlag, setModalFlag] = useState(false);
  const [rankCustomer, setRankCustomer] = useState(false);
  const [benefitLotteryTicketList, setBenefitLotteryTicketList] = useState(null);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const nextYear = (currentDate.getMonth() < 3) ? currentYear : currentYear + 1;
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)"
    },
    //     content: {
    //   position: "absolute",
    //   left: '0.5rem',
    //   right: '0.5rem',
    //   top: '10vw',
    //   bottom: 'auto',
    //   marginTop: '0.5rem',
    //   borderRadius: "0rem",
    //   padding: "0px",
    //   height: "auto",
    //   maxHeight: "80vh",
    //   overflow: "auto",
    // }
    content: {
      position: "absolute",
      borderRadius: "10px",
      top: '8vw',
      left: '1.2rem',
      right: '1.2rem',
      bottom: 'auto',
      gap: "20px",
      maxHeight: "80vh",
      overflow: "auto",
      background: "#FFFFFF",
      boxShadow: "0px 5px 10px 0px #CFCAC24D"
    }
  };
  const lotteryPeriod = `2026年5月1日～7月31日`;

  const getQrData = useCallback(async () => {
    const qr_data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/card/qrdata/${siteId}/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId })).data;
    setQrData(qr_data);
    const date = moment();
    setValidTime(date + setting.MEMBER_CARD_QRCODE_VALID_TIME * 60 * 1000);
  }, [siteId, mallId, liffAccessToken, setting]);

  //バックエンドサーバから会員に関する情報を取得
  const refreshData = useCallback(async () => {
    try {
      //各データ取得APIを先に実行
      const customer_data_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/search/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId });
      const rank_point_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/line/period_point/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      const rank_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/mastercustomerrank/line/ranklist/`, { site_id: siteId, line_id: liffAccessToken, mall_id: mallId });
      const rank_customer_info_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/search/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      const expire_point_list_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/line/expire_point_list/`, { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      const benefit_lottery_ticket_list_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit_lottery_ticket/line/${siteId}/issuelist/`, { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId });
      setBenefitLotteryTicketList((await benefit_lottery_ticket_list_promise).data);
      //会員名を取得
      const customer_data = (await customer_data_promise).data;
      const customer_info = customer_data.find(c => c.line_id === lineId && c.customer_id === customerId);
      membership_id = customer_info.card_id;

      //ランク判定期間内のポイントを取得
      const rank_point = (await rank_point_promise).data;
      const rank_point_info = rank_point.find(c => c.customer_id === customerId);
      var user_rank_point = 0;
      if (rank_point_info !== undefined) {
        user_rank_point = Number(rank_point_info.sum_point);
      }

      //ランクマスタ情報を取得
      const rank_info = (await rank_info_promise).data;

      //自分のランク情報を取得
      const rank_customer_info = (await rank_customer_info_promise).data;
      setRankCustomer(rank_customer_info);
      //自分のランク情報がない場合、最初のランクに設定
      const user_rank = rank_customer_info ? rank_customer_info.rank_id : rank_info[0].rank_id;
      if (((await benefit_lottery_ticket_list_promise).data && (await benefit_lottery_ticket_list_promise).data.find(x => x.notice_seen_flag !== constClass.FLAG.ON)) || (rank_customer_info && rank_customer_info.notice_seen_flag !== constClass.FLAG.ON)) 
      {
        setModalFlag(true);
      } else {
        setModalFlag(false);
      }

      const nextRank = rank_info.find(data => data.point_lower <= user_rank_point && user_rank_point <= data.point_upper);

      //該当するランクがない場合、最後(point_upperが最高)のランクに設定
      const next_rank = nextRank ? nextRank.rank_id : rank_info[rank_info.length - 1].rank_id;

      //有効期限が記載されているかつ、有効期限内のポイントリストを取得
      const expire_point_list = (await expire_point_list_promise).data;
      var expire_point = 0;
      var expire_point_date = null;
      //取得出来た場合、下記処理を実施
      if (expire_point_list.length) {
        //有効期限が一番近いレコードの日時情報をセット
        const expire_point_info = expire_point_list.find(c => c.customer_id === customerId);
        expire_point_date = expire_point_info.expire_date;
        //日時が同じレコードの利用可能ポイントを合計
        for (var i = 0; i < expire_point_list.length; i++) {
          if (expire_point_date === expire_point_list[i].expire_date) {
            expire_point += expire_point_list[i].point - expire_point_list[i].used_point;
          }
        }
      };

      //取得したユーザ情報をステートフックに設定
      setUserInfo({
        membership_id: membership_id,
        customer_name: customer_info.customer_name,
        available_point: customer_info.point,
        expire_point: expire_point,
        expire_point_date: expire_point_date,
        user_rank_point: user_rank_point,
        user_rank: user_rank,
        next_rank: next_rank,
        nimocle_linkage_status: customer_info.nimocle_linkage_status,
      });
      setRankInfo(rank_info);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, mallId, customerId, lineId, liffAccessToken]);

  useEffect(() => {
    refreshData();
    getQrData();
  }, [refreshData, getQrData]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        getQrData();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    var intervalId;
    intervalId = setInterval(() => {
      const date = moment();
      const sec = Math.floor((validTime - date) / 1000);
      setRestTime(sec);
      if (sec <= 0) {
        getQrData();
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [validTime, getQrData]);

  const pointRefreshClick = async () => {
    // 各種APIコール
    const params = { site_id: siteId, line_id: liffAccessToken, mall_id: mallId };
    const customerPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer/line/search/`, params);
    const customer = (await customerPromise).data;
    var my_customer = customer.find(c => c.line_id === lineId && c.customer_id === customerId);
    setUserInfo(s => ({
      ...s,
      available_point: my_customer.point,
    }));
    refreshAvailablePoints();
  };

  const noticeSeenClick = async () => {
    if (benefitLotteryTicketList && benefitLotteryTicketList.find(x => x.notice_seen_flag !== constClass.FLAG.ON)) {      
      const params = { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId };
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customer_benefit_lottery_ticket/line/noticeseen/`, params);
    }
    if (rankCustomer && rankCustomer.notice_seen_flag !== constClass.FLAG.ON) {
      const params = { site_id: siteId, customer_id: customerId, line_id: liffAccessToken, mall_id: mallId };
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/customerrank/line/noticeseen/`, params);
    }
  };

  const getJudgmentEndDay = (year, month) => {
    return new Date(year, month - 1, 0).getDate();
  };

  const judgmentEndDate = `${nextYear === 2025 ? nextYear + 1 : nextYear}/${Number(setting.RANK_JUDGMENT_MONTH) - 1}/${getJudgmentEndDay(nextYear, setting.RANK_JUDGMENT_MONTH)}`;
  const judgmentNextDate = `${nextYear === 2025 ? nextYear + 1 : nextYear}/${Number(setting.RANK_JUDGMENT_MONTH) + 1}/1`;

  return (
    <div id="membershippass" className="px-0-env">
      {qrData === null || restTime === 0 || userInfo.membership_id === null ? (
        <Loading />
      ) : (
        <React.Fragment>
          <div className="malllist">
            <div className="mallitem">
              {setting.ONE_BUILDING_URL ? (
                <a href={setting.ONE_BUILDING_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/one_building.svg`} alt={'ワンビルアイコン'} />
                </a>
              ) : (
                <img src={`/${siteId}/one_building.svg`} alt={'ワンビルアイコン'} />
              )}
            </div>
            <div className="mallitem">
              {setting.PLAZA_URL ? (
                <a href={setting.PLAZA_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/plaza.svg`} alt={'プラザアイコン'} />
                </a>
              ) : (
                <img src={`/${siteId}/plaza.svg`} alt={'プラザアイコン'} />
              )}
            </div>
            <div className="mallitem">
              {setting.STAGE_URL ? (
                <a href={setting.STAGE_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/stage.svg`} alt={'ステージアイコン'} />
                </a>
              ) : (
                <img src={`/${siteId}/stage.svg`} alt={'ステージアイコン'} />
              )}
            </div>
            <div className="mallitem">
              {setting.CHACHATOWN_URL ? (
                <a href={setting.CHACHATOWN_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/chachatown.svg`} alt={'チャチャタウンアイコン'} />
                </a>
              ) : (
                <img src={`/${siteId}/chachatown.svg`} alt={'チャチャタウンアイコン'} />
              )}
            </div>
            <div className="mallitem">
              {setting.OHASHI_URL ? (
                <a href={setting.OHASHI_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/ohashi.svg`} alt={'大橋アイコン'} />
                </a>
              ) : (
                <img src={`/${siteId}/ohashi.svg`} alt={'大橋アイコン'} />
              )}
            </div>
            <div className="mallitem">
              {setting.KASUGABARU_URL ? (
                <a href={setting.KASUGABARU_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/kasugabaru.svg`} alt={'春日原アイコン'} style={{ marginTop: '3px' }} />
                </a>
              ) : (
                <img src={`/${siteId}/kasugabaru.svg`} alt={'春日原アイコン'} style={{ marginTop: '3px' }} />
              )}
            </div>
            <div className="mallitem">
              {setting.KURUME_URL ? (
                <a href={setting.KURUME_URL} target="_blank" rel="noopener noreferrer">
                  <img src={`/${siteId}/kurume.svg`} alt={'久留米アイコン'} />
                </a>
              ) : (
                <img src={`/${siteId}/kurume.svg`} alt={'久留米アイコン'} />
              )}
            </div>
            <div className="mallitem">
              <a href="https://www.nishitetsu.jp/nishitetsushoppingpoint/" target="_blank" rel="noopener noreferrer">
                <img src={`/${siteId}/nsp.svg`} alt={'西鉄ショッピングアイコン'} className="nsp" />
              </a>
            </div>
          </div>
          <div className="frame6">
            <div className="frame22">
              {userInfo.membership_id !== null && setting.MEMBER_CARD_CODE_TYPE === '2' && qrData !== null && (
                <div className="frame13">
                  <React.Fragment>
                    <span className="qrcode-rest mx-2">二次元コードの有効時間</span>
                    <span className="qrcode-resttime">{restTime}</span>
                    <span className="qrcode-time">秒</span>
                  </React.Fragment>
                </div>
              )}
              <div className={`mt-3 card ${mallId === "1" ? "card-one" :
                mallId === "2" ? "card-solaria" :
                  mallId === "3" ? "card-stage" :
                    mallId === "4" ? "card-chacha" :
                      mallId === "5" ? "card-ohashi" :
                        mallId === "6" ? "card-kurume" :
                          mallId === "7" ? "card-kasugabaru" : ""
                }`}>
                {mallId === "1" && (
                  <React.Fragment>
                    <div className="card-name-one pt-2">
                      ONE
                    </div>
                    <div className="card-name-one">
                      FUKUOKA
                    </div>
                    <div className="card-name-one">
                      BLDG.
                    </div>
                  </React.Fragment>)
                }
                {mallId === "2" && (
                  <React.Fragment>
                    <div className="card-name-solaria pt-2">
                      SOLARIA
                    </div>
                    <div className="card-name-solaria">
                      PLAZA
                    </div>
                  </React.Fragment>)
                }
                {mallId === "3" && (
                  <React.Fragment>
                    <div className="card-name-stage pt-2">
                      SOLARIA
                    </div>
                    <div className="card-name-stage">
                      STAGE
                    </div>
                  </React.Fragment>)
                }
                {mallId === "4" && (
                  <React.Fragment>
                    <div className="card-name-chacha pt-2">
                      CHACHA
                    </div>
                    <div className="card-name-chacha">
                      TOWN
                    </div>
                  </React.Fragment>)
                }
                {mallId === "5" && (
                  <React.Fragment>
                    <div className="card-name-ohashi pt-2">
                      RAIRIA
                    </div>
                    <div className="card-name-ohashi">
                      OHASHI
                    </div>
                  </React.Fragment>)
                }
                {mallId === "6" && (
                  <React.Fragment>
                    <div className="card-name-kurume pt-2">
                      RAIRIA
                    </div>
                    <div className="card-name-kurume">
                      KURUME
                    </div>
                  </React.Fragment>)
                }
                {mallId === "7" && (
                  <React.Fragment>
                    <div className="card-name-kasugabaru pt-2">
                      RAIRIA
                    </div>
                    <div className="card-name-kasugabaru">
                      KASUGA
                    </div>
                    <div className="card-name-kasugabaru">
                      BARU
                    </div>
                  </React.Fragment>)
                }
                <div className="frame4">
                  <div className='logo'>
                    {mallId !== "4" && <img src={`/${siteId}/logo.svg`} alt={'ロゴ'} />}
                    {mallId === "4" && <img src={`/${siteId}/logo2.svg`} alt={'ロゴ'} />}
                  </div>
                  {mallId === "2" && (
                    <div className='logo-box1'>
                      <img src={`/${siteId}/cardplaza.svg`} alt={'ロゴ'} />
                    </div>
                  )}
                  {mallId === "3" && (
                    <div className='logo-box1'>
                      <img src={`/${siteId}/cardstage.svg`} alt={'ロゴ'} />
                    </div>
                  )}
                  {mallId === "4" && (
                    <div className='logo-box2'>
                      <img src={`/${siteId}/cardchachatown.svg`} alt={'ロゴ'} />
                    </div>
                  )}
                  {mallId === "5" && (
                    <div className='logo-box2'>
                      <img src={`/${siteId}/cardohashi.svg`} alt={'ロゴ'} />
                    </div>
                  )}
                  {mallId === "6" && (
                    <div className='logo-box2'>
                      <img src={`/${siteId}/cardkurume.svg`} alt={'ロゴ'} />
                    </div>
                  )}
                  {mallId === "7" && (
                    <div className='logo-box2'>
                      <img src={`/${siteId}/cardkasugabaru.svg`} alt={'ロゴ'} />
                    </div>
                  )}
                  {userInfo.membership_id !== null && setting.MEMBER_CARD_CODE_TYPE === '2' && qrData !== null && (
                    <div className="qr-box">
                      <QRCode className="qr-img" size={100} value={qrData} />
                    </div>
                  )}
                  <div className="frame3 text-center">
                    <div className={`frame7 ${mallId === "1" ? "memberid-one" :
                      mallId === "2" ? "memberid-solaria" :
                        mallId === "3" ? "memberid-stage" :
                          mallId === "4" ? "memberid-chacha" :
                            mallId === "5" ? "memberid-ohashi" :
                              mallId === "6" ? "memberid-kurume" :
                                mallId === "7" ? "memberid-kasugabaru" : ""
                      }`}>
                      {mallId !== "4" && (
                        <div className="memberid">
                          <div className="member">
                            会員<span className="id">ID</span>
                          </div>
                        </div>
                      )}
                      {mallId === "4" && (
                        <div className="memberid">
                          <div className="chachamember">
                            会員<span className="chachaid">ID</span>
                          </div>
                        </div>
                      )}
                    </div>
                    {mallId !== "4" && (
                      <div className="frame8">
                        <span className="memberid-text">{userInfo.membership_id}</span>
                      </div>
                    )}
                    {mallId === "4" && (
                      <div className="chachaframe8">
                        <span className="chachamemberid-text">{userInfo.membership_id}</span>
                      </div>
                    )}
                  </div>
                  <div className="ellipse1">
                  </div>
                  <div className="ellipse2">
                  </div>
                  <div className="ellipse3">
                  </div>
                </div>
                {mallId === "1" && (
                  <div className='crown-box'>
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "ブロンズ" && (
                      <img src={`/${siteId}/bronze.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "シルバー" && (
                      <img src={`/${siteId}/silver.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "ゴールド" && (
                      <img src={`/${siteId}/gold.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "プラチナ" && (
                      <img src={`/${siteId}/platinum.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "VIP" && (
                      <img src={`/${siteId}/vip.svg`} alt={'冠'} />
                    )}
                  </div>
                )}
                {mallId !== "1" && (
                  <div className='crown-box'>
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "ブロンズ" && (
                      <img src={`/${siteId}/othercrownbronze.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "シルバー" && (
                      <img src={`/${siteId}/othercrownsilver.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "ゴールド" && (
                      <img src={`/${siteId}/othercrowngold.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "プラチナ" && (
                      <img src={`/${siteId}/othercrownplatinum.svg`} alt={'冠'} />
                    )}
                    {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name === "VIP" && (
                      <img src={`/${siteId}/othercrownvip.svg`} alt={'冠'} />
                    )}
                  </div>
                )}
              </div>
            </div>
            {benefitLotteryTicketList.length > 0 &&
              <React.Fragment>
                <div className="mt-4 d-flex justify-content-center">
                  <div className="text-center flex-column">
                    <div className="button text-black bg-lightwhite position-relative">
                      {benefitLotteryTicketList && benefitLotteryTicketList.find(x => x.royalty_seen_flag !== constClass.FLAG.ON) &&
                        <i className="bi bi-circle-fill blink-color blink blink-state"></i>
                      }
                      <Link to={`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.RANKUP}`} className="text-black" onClick={() => pointRefreshClick()}>
                        <div>抽選キャンペーン応募はこちら！</div>
                      </Link>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            }
            <div className="frame28">
              <div className="frame24">
                <div className="frame10">
                  <div className="frame11">
                    <div className="points-held">
                      保有ポイント
                    </div>
                    <div className="frame9">
                      <div className="points">
                        {userInfo.available_point.toLocaleString()}pt
                      </div>
                    </div>
                  </div>
                  <div className="frame48">
                    <div className="frame47">
                      <div className="frame29">
                        <div className="points-expire-text">
                          失効するポイント
                        </div>
                        <div className="points-expire">
                          {userInfo.expire_point.toLocaleString()}pt
                        </div>
                      </div>
                      <div className="frame12">
                        <div className="expiration-date-text">
                          有効期限
                        </div>
                        <div className="expiration-date">
                          {userInfo.expire_point_date === null && "-"}
                          {userInfo.expire_point_date !== null && moment(userInfo.expire_point_date).format('YYYY.MM.DD')}
                        </div>
                      </div>
                    </div>
                    <div className="frame27">
                      <div className="text-center">
                        <div className="button text-black bg-lightwhite">
                          <Link to={`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.PAIDTICKETLIST}`} className="text-black" onClick={() => pointRefreshClick()}><div>ポイントを使う</div></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="frame46">
                  {Number(currentDate.getMonth() + 1) === Number(setting.RANK_JUDGMENT_MONTH) && currentDate.getFullYear() !== 2025 ? (
                    <div className="rank-date-from">会員ランク集計中</div>
                  ) : (
                    <React.Fragment>
                      {rankInfo.find(x => x.rank_id === (userInfo.next_rank + 1)) ? (
                        <div className="frame44">
                          <div className="rank-date-from">{judgmentEndDate}</div>
                          <div className="rank-text">までにあと</div>
                          <div className="rank-date-from">
                            <React.Fragment>
                              <b>{(rankInfo.find(x => x.rank_id === (userInfo.next_rank + 1)).point_lower - userInfo.user_rank_point).toLocaleString()}</b> ポイント
                            </React.Fragment>
                          </div>
                          <div className="points-expire-text">貯めると</div>
                        </div>
                      ) : ""}
                      <div className="frame45">
                        <div className="rank-date-from">{judgmentNextDate}</div>
                        <div className="points-expire-text">から</div>
                        {rankInfo.find(x => x.rank_id === (userInfo.next_rank + 1)) ? (
                          <React.Fragment>
                            <div className="rank-date-from">{(rankInfo.find(x => x.rank_id === (userInfo.next_rank + 1)).rank_name)}会員</div>
                            <div className="points-expire-text">になります</div>
                          </React.Fragment>
                        ) : rankInfo.find(x => x.rank_id === (userInfo.next_rank)) ? (
                          <React.Fragment>
                            <div className="rank-date-from">{(rankInfo.find(x => x.rank_id === (userInfo.next_rank)).rank_name)}会員</div>
                            <div className="points-expire-text">になります</div>
                          </React.Fragment>
                        ) : <React.Fragment></React.Fragment>}
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
              <div className="frame99">
                <div className="pb-3">
                  <div className="col text-center">
                    {setting.MEMBER_BONUS_URL ? (
                      <a href={setting.MEMBER_BONUS_URL} className="link-blue" target="_blank" rel="noopener noreferrer"><u>会員特典について</u></a>
                    ) : (
                      <div className="text-center mt-3">
                        <button className="btn btn-link expiration-date-text w-100" onClick={() => setShowRankGuide(true)}>会員特典について</button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-center">
                  <div className="button text-black bg-lightwhite">
                    <Link to={`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.POINTHISTORY}`} className="text-black"><div>ポイント履歴</div></Link>
                  </div>
                </div>
              </div>
              {Common.getFunctionEnabled(setting, 'NIMOCLE_ID_LINKAGE') && userInfo.nimocle_linkage_status !== constClass.NIMOCLE_LINKAGE_STATUS.REG && (
                <React.Fragment>
                  {/* 固定表示するバナーの分だけ、後続コンテンツが隠れないように高さを確保 */}
                  <div style={{ height: '74px' }} aria-hidden="true"></div>
                  {createPortal(
                    <div
                      style={{
                        position: 'fixed',
                        left: '20px',
                        right: '20px',
                        bottom: `calc(${footerHeight}px + env(safe-area-inset-bottom, 0px) + 10px)`,
                        zIndex: 50,
                        userSelect: 'none',
                        WebkitUserSelect: 'none',
                        WebkitTouchCallout: 'none',
                      }}
                    >
                      <Link
                        to={`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.USERCHANGE}`}
                        className="text-black d-flex align-items-center"
                        style={{
                          gap: '10px',
                          background: '#FAF8F5',
                          border: '1px solid #ECE8E1',
                          borderRadius: '12px',
                          padding: '12px 14px',
                          boxShadow: '0px 4px 10px 0px #CFCAC24D',
                          textDecoration: 'none',
                        }}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b06a1e" strokeWidth="1.8"><rect x="2.5" y="5.5" width="19" height="13" rx="2"/><path d="M2.5 9.5h19"/></svg>
                        <span style={{ flex: 1, fontSize: '0.78rem', fontWeight: 'bold' }}>nimocle ID連携してクレカ払いすると、<br/>ポイントが翌月10日に自動付与されます</span>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#b7b7b7" strokeWidth="2.6" strokeLinecap="round"><path d="M9 6l6 6-6 6" /></svg>
                      </Link>
                    </div>,
                    document.body
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
      {showRankGuide && (
        <Modal isOpen={showRankGuide} style={modalStyle} onRequestClose={() => setShowRankGuide(false)}>
          <div className="m-0 py-2 vh-50 overflow-auto bg-lightwhite text-center">
            <div className="col-auto px-0 align-self-start">
              <div className="text-right px-0" onClick={() => setShowRankGuide(false)}>&times;</div>
            </div>
            <img src={`/${siteId}/rankguide.png`} alt="ランク情報" />
          </div>
        </Modal>
      )}
      {modalFlag && (
        <Modal isOpen={modalFlag} style={modalStyle} onRequestClose={() => { setModalFlag(false); noticeSeenClick(); }}>
          <div className="container-fluid section-white m-0 py-2 vh-50 overflow-auto z-index-10">
            <div className="row mx-0 px-3-env col-12 d-flex justify-content-center align-items-center position-relative">
              <span className="notice_title">お知らせ</span>
              <div className="text-right px-0 position-absolute notice_cancel_button" onClick={() => { setModalFlag(false); noticeSeenClick(); }}>
                <img className="" src={CloseImg} alt="閉じる" />
              </div>
            </div>
            <div className='notice_container'>
              {rankCustomer && rankCustomer.notice_seen_flag !== constClass.FLAG.ON &&
                <React.Fragment>
                  <div className="notice_rankup_text my-2">
                    <span>
                      {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank)
                        ? `${rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name}ランクが確定しました！`
                        : 'ランクが確定しました！'}
                    </span>
                  </div>
                  {(rankInfo.length > 0 && Number(rankInfo.find(x => x.rank_id === userInfo.user_rank)?.point_give) > 0) && (
                    <React.Fragment>
                      <div className="notice_rankup_detail_text mt-3">
                        <span>{rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name}ランクの特典として、</span>
                      </div>
                      <div className="notice_rankup_detail_text">
                        <span>ボーナスポイントを受け取りました。</span>
                      </div>
                      <div className="notice_rankup_label my-3">
                        <div className="frame60">ボーナスポイント:</div>
                        <div className='notice_point_number_text'>
                          {rankInfo.length > 0 && rankInfo.find(x => x.rank_id === userInfo.user_rank).point_give}
                          <span className='notice_point_text'>ポイント</span>
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              }
              {(benefitLotteryTicketList.length > 0 && benefitLotteryTicketList.filter(x => x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length > 0) && (
                <React.Fragment>
                  <div className="notice_rankup_detail_text">
                    <span>{rankInfo && rankInfo.find(x => x.rank_id === userInfo.user_rank) ? `${rankInfo.find(x => x.rank_id === userInfo.user_rank).rank_name}ランクの特典として、` : ''}</span>
                  </div>
                  <div className="notice_rankup_detail_text">
                    <span>抽選券を受け取りました。</span>
                  </div>
                  {/* <div className="notice_rankup_label my-3">
                    <div className="frame60">抽選券:</div>
                    <div className='notice_point_number_text'>
                      {benefitLotteryTicketList.length > 0 && benefitLotteryTicketList.filter(x => x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length}
                      <span className='notice_point_text'>枚</span>
                    </div>
                  </div> */}
                </React.Fragment>
              )}
              {(benefitLotteryTicketList.length > 0 && benefitLotteryTicketList.filter(x => x.status === constClass.BENEFIT_LOTTERY_TICKET_STATUS.ISSUED).length > 0) && (
                <React.Fragment>
                  <div className="notice_rankup_detail_text my-3">
                    <span>抽選キャンペーンに応募できます。<br />抽選期間 {lotteryPeriod}</span>
                  </div>
                  <div className="row mx-0 px-3-env">
                    <div className="col-12 text-center p-0">
                      <div className="button text-black bg-lightwhite">
                        <Link to={`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.RANKUP}`} className="text-black" onClick={() => { noticeSeenClick(); }}><div>抽選キャンペーン応募はこちら！</div></Link>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-3">
                    <button className="btn btn-link expiration-date-text w-100" onClick={() => setShowLotteryGuide(true)}>抽選キャンペーン詳細はこちら</button>
                  </div>
                </React.Fragment>
              )}
            </div>
            <div className="row mx-0 justify-content-center align-items-center">
              <div className="text-center p-0">
                <button
                  className="button text-black bg-white text-center align-middle"
                  onClick={() => { setModalFlag(false); noticeSeenClick(); }}>
                  閉じる
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {showLotteryGuide && (
        <Modal isOpen={showLotteryGuide} style={modalStyle} onRequestClose={() => setShowLotteryGuide(false)}>
          <div className="m-0 py-2 bg-lightwhite text-center">
            <div className="col-auto px-0 align-self-start">
              <div className="text-right px-0" onClick={() => setShowLotteryGuide(false)}>&times;</div>
            </div>
            <img src={`/${siteId}/lotteryguide.jpg`} alt="抽選キャンペーン情報" className='w-100' />
          </div>
        </Modal>
      )}
    </div>
  );
}

export default MembershipPass;